import type { InjectionKey, ModelRef } from 'vue';

export type SortDirection = 'asc' | 'desc';

export const sortableTableKey = Symbol('sortableTable') as InjectionKey<{
  sortColumn: ModelRef<string>;
  sortDirection: ModelRef<SortDirection>;
}>;
